<template>
  <div class="outerbox onoutbox">
    <div class="innercoreversion contene">
      <div class="titlon">
        <img width="712px" height="47px" src="../image//titleonhave.png" alt="" />
      </div>
      <div class="bouttonbox">
        <div
          class="everonbox"
          :class="active == 0 ? 'active animate__animated animate__bounce animate__repeat-2' : ''"
          @click="chagnactive(0)"
        >
          <img width="68px" height="64px" src="../image/tanhome.png" alt="" />
          <div class="titleAIx">智能巡店</div>
          <p>通过监控系统结合AI能力，对企业的检查标准进行远程巡检</p>
        </div>
        <div
          class="everonbox"
          :class="active == 1 ? 'active animate__animated animate__bounce animate__repeat-2' : ''"
          @click="chagnactive(1)"
        >
          <img width="68px" height="64px" src="../image/device.png" alt="" />
          <div class="titleAIx">智能营建</div>
          <p>进度管控，远程管控，质量管理，远程验收</p>
        </div>
        <div
          class="everonbox"
          :class="active == 2 ? 'active animate__animated animate__bounce animate__repeat-2' : ''"
          @click="chagnactive(2)"
        >
          <img width="68px" height="64px" src="../image/comper.png" alt="" />
          <div class="titleAIx">智能设备</div>
          <p>设备接入，把传统设备通过智能控制升级为智能设备</p>
        </div>
        <div
          class="everonbox"
          :class="active == 3 ? 'active animate__animated animate__bounce animate__repeat-2' : ''"
          @click="chagnactive(3)"
        >
          <img width="68px" height="64px" src="../image/aiba.png" alt="" />
          <div class="titleAIx">AI场景搭建</div>
          <p>能源智能管控、控营运监测、 AI控温、AI门店实景直播</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'projEctfour',
  data() {
    return {
      active: 0,
    }
  },
  methods: {
    chagnactive(eve) {
      this.active = eve
      this.$emit('cahgnactivk', eve)
    },
  },
}
</script>

<style lang="less" scoped>
.onoutbox {
  height: 563px;
  background: linear-gradient(to bottom, #fff 70%, rgba(243, 249, 253, 1) 30%);
  .contene {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .titlon {
      font-weight: 500;
      font-size: 18px;
      color: #57cc9a;
      margin-bottom: 48px;
    }
    .bouttonbox {
      width: 100%;
      display: flex;
      font-weight: 500;
      font-size: 14px;
      color: #000;
      justify-content: space-around;
      .everonbox {
        box-sizing: border-box;
        padding: 69px 41px;
        width: 282px;
        height: 296px;
        background: #ffffff;
        box-shadow: 0px 2px 20px 0px rgba(116, 126, 122, 0.2);
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #e1e1e1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .titleAIx {
          margin: 14px 0 12px 0;
          font-weight: 500;
          font-size: 18px;
        }
        &:hover {
          color: #57cc9a;
        }
      }
      .active {
        color: #57cc9a;
      }
    }
  }
}
</style>